import { Spin } from 'antd'
import './style.less'

export default function Demo(props) {
  const prefixCls = 'bytfc'
  const init = props.init
  const loading = props.loading
  const tips = props.tips
  const errorMsg = props.errorMsg
  const errorCode = props.errorCode
  const errorExtra = props.errorExtra

  return (
    <>
      {init ? (
        <div className={`${prefixCls}-spin`}>
          <Spin spinning={init || loading} tip={tips}></Spin>
        </div>
      ) : errorMsg ? (
        <div className={`${prefixCls}-empty`}>
          <div className={`${prefixCls}-empty-bg`}>
            <i type={errorCode || 'default'}></i>
          </div>
          <p className={`${prefixCls}-empty-desc`}>{errorMsg}</p>
          {errorExtra}
        </div>
      ) : (
        props.children
      )}
    </>
  )
}
